import { css } from '@emotion/react';
import { type PropsWithChildren } from 'react';

const bulletItemStyle = css({
  marginTop: 4,
});

export const BulletItem = ({ children }: PropsWithChildren) => (
  <div css={bulletItemStyle}>{'• '}{children}</div>
);
